import { useEffect, useState } from "react";
import EditBasicInfoModal from "./EditBasicInfoModal";
import EditAdvertiserBenefitsModal from "./EditAdvertiserBenefitsModal";
import EditContactInfoModal from "./EditContactInfoModal";
import EditWhyPartnerModal from "./EditWhyPartnerModal";
import LocationMap from "./LocationMap";
import ScreensGallery from "./ScreensGallery";
import { useGlobalStates } from "../../utlis/ClubsContext";
import { UserRole } from "../../utlis/constant";
import axios from "axios";
import Cookies from "js-cookie";

const formatAddress = (...parts) =>
  parts.filter((part) => part != null && `${part}`.trim() !== "").join(", ");

const OverviewTab = () => {
  const [showEditModal, setShowEditModal] = useState(false);
  const [showContactModal, setShowContactModal] = useState(false);
  const [showWhyPartnerModal, setShowWhyPartnerModal] = useState(false);
  const [showAdvertiserBenefitsModal, setShowAdvertiserBenefitsModal] =
    useState(false);
  const { selectedClub, userRole } = useGlobalStates();
  console.log("selectedClub from overview tab", selectedClub);
  const [showFullDescription, setShowFullDescription] = useState(false);
  const [qrCode, setQrCode] = useState(null);
  const [qrLoading, setQrLoading] = useState(true);

  const handleSaveWhyPartner = () => {};
  useEffect(() => {
    if (selectedClub?.clubSlug) {
      generateQrCode();
    }
  }, [selectedClub?.clubSlug]);

  console.log("selectedClub", selectedClub);
  const generateQrCode = async () => {
    try {
      setQrLoading(true);

      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/club/qr/${selectedClub?.clubSlug}`,
        {
          responseType: "blob",
          headers: {
            Authorization: `Bearer ${Cookies.get("token")}`,
          },
        },
      );
      console.log("qr response", response);

      const imageUrl = URL.createObjectURL(response.data);
      setQrCode(imageUrl);
      console.log("imageUrl", imageUrl);
    } catch (error) {
      console.log("error while generating qr code", error);
    } finally {
      setQrLoading(false);
    }
  };

  return (
    <div className="space-y-4">
      {/* Basic Information Section */}
      <div className="bg-white rounded-xl p-6 main-shadow">
        <div className="flex justify-between items-start mb-6">
          <h2 className="text-xl font-semibold text-black tracking-[0] leading-[normal]">
            Basic Information
          </h2>
          <button
            onClick={() => setShowEditModal(true)}
            disabled={userRole === UserRole.Viewer}
            className={`flex items-center gap-2 text-base font-medium text-black hover:text-primary transition-colors  ${userRole === UserRole.Viewer ? "cursor-not-allowed opacity-50" : "cursor-pointer"}`}
          >
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M11.333 2.00004C11.5081 1.82494 11.716 1.68605 11.9447 1.59129C12.1735 1.49653 12.4187 1.44775 12.6663 1.44775C12.914 1.44775 13.1592 1.49653 13.3879 1.59129C13.6167 1.68605 13.8246 1.82494 13.9997 2.00004C14.1748 2.17513 14.3137 2.383 14.4084 2.61178C14.5032 2.84055 14.552 3.08575 14.552 3.33337C14.552 3.58099 14.5032 3.82619 14.4084 4.05497C14.3137 4.28374 14.1748 4.49161 13.9997 4.66671L4.99967 13.6667L1.33301 14.6667L2.33301 11L11.333 2.00004Z"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            Edit
          </button>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {/* Upload Logo */}
          <div className="flex items-start gap-4">
            <div className="w-16 h-16 rounded-full overflow-hidden bg-gray-200 flex-shrink-0">
              <img
                src={selectedClub?.clubLogoFile?.fileUrl}
                alt="Club logo"
                className="w-full h-full object-cover"
              />
            </div>
            <div>
              <p className="text-base font-medium text-black tracking-[0] leading-[normal] mb-1">
                Upload logo
              </p>
              <p className="text-sm font-normal text-textcolor tracking-[0] leading-[normal]">
                Format png, jpg
              </p>
            </div>
          </div>

          {/* Club Name */}
          <div className="flex justify-between">
            <div>
              <p className="text-sm font-normal text-textcolor tracking-[0] leading-[normal] mb-2">
                Club Name
              </p>
              <p className="text-base font-semibold text-black tracking-[0] leading-[normal]">
                {selectedClub?.clubName}
              </p>
            </div>
            {qrLoading ? (
              <div className="w-20 h-full rounded-md bg-gray-200 animate-pulse" />
            ) : (
              <div className="">
                <img src={qrCode} alt="qr code" className="w-20" />
              </div>
            )}
          </div>
          <div>
            <p className="text-sm font-normal text-textcolor tracking-[0] leading-[normal] mb-2">
              Club Tagline
            </p>
            <p className="text-[18px] font-normal text-textcolor tracking-[0] leading-[24px]">
              {selectedClub?.clubTagline || "-"}
            </p>
          </div>
        </div>

        {/* Description */}
        <div className="mt-6">
          <p className="text-base font-normal text-textcolor tracking-[0] leading-[normal] mb-2">
            Description
          </p>
          <p className="text-[18px] font-normal text-textcolor tracking-[0] leading-[24px]">
            {selectedClub?.description?.length > 500 ? (
              <>
                {showFullDescription
                  ? selectedClub?.description
                  : selectedClub?.description.slice(0, 500) + "..."}

                <span
                  className="text-blue-600 cursor-pointer p-2"
                  onClick={() => setShowFullDescription(!showFullDescription)}
                >
                  {showFullDescription ? "view less" : "view more"}
                </span>
              </>
            ) : (
              selectedClub?.description
            )}
          </p>
        </div>
      </div>

      {/* Contact Information Section */}
      <div className="bg-white rounded-xl p-6 main-shadow">
        <div className="flex justify-between items-start mb-6">
          <h2 className="text-xl font-semibold text-black tracking-[0] leading-[normal]">
            Contact Information
          </h2>
          <button
            disabled={userRole === UserRole.Viewer}
            onClick={() => setShowContactModal(true)}
            className={`flex items-center gap-2 text-base font-medium text-black hover:text-primary transition-colors  ${userRole === UserRole.Viewer ? "cursor-not-allowed opacity-50" : "cursor-pointer"}`}
          >
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M11.333 2.00004C11.5081 1.82494 11.716 1.68605 11.9447 1.59129C12.1735 1.49653 12.4187 1.44775 12.6663 1.44775C12.914 1.44775 13.1592 1.49653 13.3879 1.59129C13.6167 1.68605 13.8246 1.82494 13.9997 2.00004C14.1748 2.17513 14.3137 2.383 14.4084 2.61178C14.5032 2.84055 14.552 3.08575 14.552 3.33337C14.552 3.58099 14.5032 3.82619 14.4084 4.05497C14.3137 4.28374 14.1748 4.49161 13.9997 4.66671L4.99967 13.6667L1.33301 14.6667L2.33301 11L11.333 2.00004Z"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            Edit
          </button>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {/* Email */}
          <div className="flex items-start gap-3">
            <svg
              className="w-5 h-5 text-textcolor mt-0.5 flex-shrink-0"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M3.33334 3.33334H16.6667C17.5833 3.33334 18.3333 4.08334 18.3333 5.00001V15C18.3333 15.9167 17.5833 16.6667 16.6667 16.6667H3.33334C2.41668 16.6667 1.66668 15.9167 1.66668 15V5.00001C1.66668 4.08334 2.41668 3.33334 3.33334 3.33334Z"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M18.3333 5L10 10.8333L1.66666 5"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            <div>
              <p className="text-sm font-normal text-textcolor tracking-[0] leading-[normal] mb-1">
                Email
              </p>
              <p className="text-base font-normal text-black tracking-[0] leading-[24px]">
                {selectedClub?.contactEmail || "-"}
              </p>
            </div>
          </div>

          {/* Phone */}
          <div className="flex items-start gap-3">
            <svg
              className="w-5 h-5 text-textcolor mt-0.5 flex-shrink-0"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M18.3333 14.1V16.6C18.3343 16.832 18.2867 17.0617 18.1937 17.2744C18.1008 17.487 17.9644 17.6779 17.7934 17.8349C17.6224 17.9919 17.4205 18.1112 17.2005 18.1855C16.9805 18.2599 16.7476 18.2875 16.5167 18.2667C13.9523 17.988 11.489 17.1118 9.32498 15.7084C7.31151 14.4289 5.60443 12.7218 4.32499 10.7084C2.91663 8.53438 2.04019 6.05913 1.76665 3.48335C1.74595 3.25313 1.77334 3.02094 1.84718 2.80178C1.92102 2.58263 2.03963 2.38141 2.19562 2.21082C2.35162 2.04024 2.54149 1.90396 2.75314 1.81079C2.96479 1.71762 3.19348 1.66948 3.42499 1.66669H5.92499C6.32953 1.66274 6.72148 1.80593 7.02812 2.06965C7.33476 2.33337 7.53505 2.69958 7.59165 3.10002C7.69717 3.90006 7.89286 4.68563 8.17499 5.44169C8.28713 5.73998 8.31139 6.06412 8.24491 6.37565C8.17843 6.68718 8.02404 6.97341 7.79998 7.20002L6.74165 8.25835C7.92795 10.3446 9.65536 12.072 11.7417 13.2584L12.8 12.2C13.0266 11.976 13.3128 11.8216 13.6244 11.7551C13.9359 11.6886 14.26 11.7129 14.5583 11.825C15.3144 12.1072 16.1 12.3029 16.9 12.4084C17.3048 12.4655 17.6745 12.6694 17.9388 12.9812C18.203 13.293 18.3435 13.6913 18.3333 14.1Z"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            <div>
              <p className="text-sm font-normal text-textcolor tracking-[0] leading-[normal] mb-1">
                Phone
              </p>
              <p className="text-base font-normal text-black tracking-[0] leading-[24px]">
                {selectedClub?.contactPhone || "-"}
              </p>
            </div>
          </div>

          {/* Address */}
          <div className="col-span-1 md:col-span-2 flex gap-3 items-start">
                <svg
                className="w-5 h-5 text-textcolor mt-0.5 flex-shrink-0"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M17.5 8.33334C17.5 14.1667 10 19.1667 10 19.1667C10 19.1667 2.5 14.1667 2.5 8.33334C2.5 6.34421 3.29018 4.4366 4.6967 3.03007C6.10322 1.62355 8.01088 0.833344 10 0.833344C11.9891 0.833344 13.8968 1.62355 15.3033 3.03007C16.7098 4.4366 17.5 6.34421 17.5 8.33334Z"
                  stroke="currentColor"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M10 10.8333C11.3807 10.8333 12.5 9.71406 12.5 8.33334C12.5 6.95263 11.3807 5.83334 10 5.83334C8.61929 5.83334 7.5 6.95263 7.5 8.33334C7.5 9.71406 8.61929 10.8333 10 10.8333Z"
                  stroke="currentColor"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              <div className="flex-1">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4 ">
                {selectedClub?.addresses?.length ? (
                  selectedClub.addresses.map((addr, index) => {
                    const formatted = formatAddress(addr?.contactAddress);
                    return (
                      <div key={index}>
                        <div>
                          {" "}
                          <p className="text-sm font-normal text-textcolor tracking-[0] leading-[normal] mb-1">
                            Address {index + 1}
                          </p>
                          <p
                            key={index}
                            className="text-base font-normal text-black leading-[24px] mb-1"
                          >
                            {formatted}
                          </p>
                        </div>
                      </div>
                    );
                  })
                ) : (
                  <p className="text-base text-black">-</p>
                )}
              </div>
              </div>
          </div>
        </div>
      </div>

      <LocationMap
        locations={selectedClub?.addresses?.map((addr) => ({
          lat: addr.latitude,
          lng: addr.longitude,
          address: formatAddress(
            addr.contactAddress,
            addr.contactCity,
            addr.contactState,
            addr.contactCountry,
          ),
        }))}
      />

      {/* Screens Placement Gallery Section */}
      <ScreensGallery />

      {/* Why Partner Section */}
      <div className="bg-white rounded-xl p-6 main-shadow">
        <div className="flex justify-between items-start mb-6">
          <div>
            <h2 className="text-xl font-semibold text-black tracking-[0] leading-[normal] mb-2">
              Why Partner Section
            </h2>
            <p className="text-lg font-normal text-textcolor tracking-[0] leading-[20px]">
              Upload high-quality images to showcase your venue and ad spaces.
            </p>
          </div>
          <button
            onClick={() => setShowWhyPartnerModal(true)}
            disabled={userRole === UserRole.Viewer}
            className={`flex items-center gap-2 text-base font-medium text-black hover:text-primary transition-colors  ${userRole === UserRole.Viewer ? "cursor-not-allowed opacity-50" : "cursor-pointer"}`}
          >
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M11.333 2.00004C11.5081 1.82494 11.716 1.68605 11.9447 1.59129C12.1735 1.49653 12.4187 1.44775 12.6663 1.44775C12.914 1.44775 13.1592 1.49653 13.3879 1.59129C13.6167 1.68605 13.8246 1.82494 13.9997 2.00004C14.1748 2.17513 14.3137 2.383 14.4084 2.61178C14.5032 2.84055 14.552 3.08575 14.552 3.33337C14.552 3.58099 14.5032 3.82619 14.4084 4.05497C14.3137 4.28374 14.1748 4.49161 13.9997 4.66671L4.99967 13.6667L1.33301 14.6667L2.33301 11L11.333 2.00004Z"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            Edit
          </button>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center">
          {/* Partner Image */}
          <div className="w-full h-[300px] md:h-[400px] lg:h-[500px] rounded-[8px] bg-[#F4F4F4] shadow-[0_1px_17.9px_1px_#DBDBDB] overflow-hidden">
            {selectedClub?.partnerImageUrl ? (
              <img
                src={selectedClub?.partnerImageFile?.fileUrl}
                alt="Partner"
                className="w-full h-full object-cover"
              />
            ) : (
              <div className="flex flex-col items-center justify-center h-full text-gray-400">
                <svg
                  width="48"
                  height="48"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  className="mb-2"
                >
                  <path
                    d="M21 15V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V15M17 8L12 3M12 3L7 8M12 3V15"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
                <p className="text-lg font-medium">No image uploaded</p>
              </div>
            )}
          </div>

          {/* Partner Solutions */}
          <div className="space-y-6">
            {selectedClub?.partnerSolutions?.length > 0 ? (
              selectedClub?.partnerSolutions?.map((solution, index) => (
                <div key={index} className="space-y-2">
                  <h3 className="text-lg font-semibold text-black">
                    {solution?.heading}
                  </h3>
                  <p className="text-base font-normal text-textcolor leading-[24px]">
                    {solution?.description}
                  </p>
                </div>
              ))
            ) : (
              <p className="text-center">No data found</p>
            )}
          </div>
        </div>
      </div>

      <div className="bg-white rounded-xl p-6 main-shadow">
        <div className="flex justify-between items-start mb-6">
          <div>
            <h2 className="text-xl font-semibold text-black tracking-[0] leading-[normal] mb-2">
              Advertiser Benefits Section
            </h2>
            <p className="text-lg font-normal text-textcolor tracking-[0] leading-[20px]">
              Key messaging shown for advertiser-facing benefits.
            </p>
          </div>
          <button
            onClick={() => setShowAdvertiserBenefitsModal(true)}
            disabled={userRole === UserRole.Viewer}
            className={`flex items-center gap-2 text-base font-medium text-black hover:text-primary transition-colors  ${
              userRole === UserRole.Viewer
                ? "cursor-not-allowed opacity-50"
                : "cursor-pointer"
            }`}
          >
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M11.333 2.00004C11.5081 1.82494 11.716 1.68605 11.9447 1.59129C12.1735 1.49653 12.4187 1.44775 12.6663 1.44775C12.914 1.44775 13.1592 1.49653 13.3879 1.59129C13.6167 1.68605 13.8246 1.82494 13.9997 2.00004C14.1748 2.17513 14.3137 2.383 14.4084 2.61178C14.5032 2.84055 14.552 3.08575 14.552 3.33337C14.552 3.58099 14.5032 3.82619 14.4084 4.05497C14.3137 4.28374 14.1748 4.49161 13.9997 4.66671L4.99967 13.6667L1.33301 14.6667L2.33301 11L11.333 2.00004Z"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            Edit
          </button>
        </div>

        <div className="space-y-6">
          <p className="text-sm font-semibold text-black tracking-[0] leading-[normal] mb-1">
            Title
          </p>
          <h3 className="text-lg font-normal text-textcolor">
            {selectedClub?.advertiserBenefitsTitle || "-"}
          </h3>
          <p className="text-sm font-semibold text-black tracking-[0] leading-[normal] mb-1">
            Description
          </p>
          <p className="text-base font-normal text-textcolor leading-[24px]">
            {selectedClub?.advertiserBenefitsDescription || "-"}
          </p>
        </div>
      </div>

      {/* Edit Basic Info Modal */}
      <EditBasicInfoModal
        isOpen={showEditModal}
        onClose={() => setShowEditModal(false)}
        initialData={{
          clubName: selectedClub?.clubName,
          clubTagline: selectedClub?.clubTagline,
          description: selectedClub?.description,
          logo: selectedClub?.clubLogoFile,
        }}
      />

      {/* Edit Contact Info Modal */}
      <EditContactInfoModal
        isOpen={showContactModal}
        onClose={() => setShowContactModal(false)}
        initialData={{
          phone: selectedClub?.contactPhone,
          email: selectedClub?.contactEmail,
          addresses:
            selectedClub?.addresses?.map((addr) => ({
              contactAddress: addr.contactAddress,
              contactCity: addr.contactCity,
              contactState: addr.contactState,
              contactZip: addr.contactZip,
              contactCountry: addr.contactCountry,
              latitude: addr.latitude,
              longitude: addr.longitude,
            })) || [],
        }}
      />

      {/* Edit Why Partner Section Modal */}
      <EditWhyPartnerModal
        isOpen={showWhyPartnerModal}
        onClose={() => setShowWhyPartnerModal(false)}
        initialData={{
          image: selectedClub?.partnerImageFile,
          items: selectedClub?.partnerSolutions,
        }}
        onSave={handleSaveWhyPartner}
      />

      <EditAdvertiserBenefitsModal
        isOpen={showAdvertiserBenefitsModal}
        onClose={() => setShowAdvertiserBenefitsModal(false)}
        initialData={{
          title: selectedClub?.advertiserBenefitsTitle,
          description: selectedClub?.advertiserBenefitsDescription,
        }}
      />
    </div>
  );
};

export default OverviewTab;
